import { Box, CircularProgress } from '@mui/material';
import { FC } from 'react';

interface AppLoadingLoadingProps {
  loading: boolean;
}
const AppLoading: FC<AppLoadingLoadingProps> = ({ loading }) => {
  if (loading) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: 10000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0,0,0,0.15)',
        }}
      >
        <CircularProgress size='5rem' />
      </Box>
    );
  }
  return;
};

export default AppLoading;
